import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/logic/app.config';
import { AppComponent } from './app/logic/app.component';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
